(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.epic-urgency');
    if (!root) return;

    // Config desde data-attributes
    var showStock = (root.dataset.showStock || 'true') === 'true';
    var stockText = root.dataset.stockText || '¡Quedan pocas unidades!';
    var min = parseInt(root.dataset.viewersMin || '5', 10);
    var max = parseInt(root.dataset.viewersMax || '20', 10);

    // Key por producto para que sea estable durante la sesión
    var productId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id') || 'default';
    var key = 'epic_viewers_' + productId;

    function clamp(n, a, b){ return Math.max(a, Math.min(b, n)); }
    function randInt(a, b){ return Math.floor(Math.random() * (b - a + 1)) + a; }

    var current = parseInt(sessionStorage.getItem(key) || '', 10);
    if (isNaN(current)) {
      current = randInt(min, max);
      sessionStorage.setItem(key, current);
    }

    // Pinta contenido
    if (showStock) {
      var pill = root.querySelector('#epic-pill');
      if (pill) pill.textContent = stockText;
    }
    var viewersEl = root.querySelector('#epic-viewers');
    if (viewersEl) viewersEl.textContent = current;

    // Pequeña oscilación entre min–max cada 9–15s
    setInterval(function () {
      var delta = (Math.random() < 0.5 ? -1 : 1) * (Math.random() < 0.5 ? 1 : 2);
      current = clamp(current + delta, min, max);
      if (viewersEl) viewersEl.textContent = current;
      sessionStorage.setItem(key, current);
    }, randInt(9000, 15000));

    // (Opcional) Si ya tenías cuenta atrás, inicialízala aquí
    var timer = root.querySelector('#epic-timer');
    if (timer) { timer.textContent = ''; } // o pinta tu countdown si quieres
  });
})();
